import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import { Icon, type IconName } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

type AlertType = 'error' | 'warning' | 'info' | 'success' | ''

type AlertProps = PropsWithChildren<
  PropsWithClassName<{
    title?: string
    type?: AlertType
    icon?: IconName
  }>
>

export const AdminAlert = ({
  children,
  className,
  title,
  type,
  icon,
}: AlertProps) => {
  return (
    <div
      className={clsx('alert', className, {
        'alert-error': type === 'error',
        'alert-warning': type === 'warning',
        'alert-info': type === 'info',
        'alert-success': type === 'success',
      })}
    >
      {icon && <Icon icon={icon} />}
      {!!title && <div>{title}</div>}
      {children}
    </div>
  )
}

export const AdminErrorAlert = ({
  children,
  className,
  title,
}: Omit<AlertProps, 'type'>) => {
  return (
    <AdminAlert type="error" className={className} title={title}>
      {children}
    </AdminAlert>
  )
}
